import "./Characters.css";
import CharList from "../../components/Character/CharacterList/CharList";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../Services/AppInsightService";

const Characters: React.FC = () => {
    return (
        <div className="char-content">
            <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", }}>
                <div className="char-text">
                    <h2>How do you feel today?</h2>
                    More importantly how do you feel right now?<br />
                    Are you feeling couragious like a valiant Fighter, or self aware and spiritually centered like a holy Priest?
                    Maybe you are feeling all knowing and omnipotent like a powerful Sorceress or Mage?
                    Could it be you are feeling happy and cheerful and just want to dance and sing like a playful Bard?
                    Here in the space of My Adventure you can explore those feelings and see what adventure and excitement await you on a journey to explore how you are feeling. 
                </div>
                <div className="char-text">
                    <b>Dev notes</b>:<br />
                    My plan is to make the Class names mentioned above have an onHover to display the basic description for each class.<br />
                    Whith that said, it then only makes sense to expand the above to have more mentions of the other classes that are planned to be available as well.<br />
                    We shall see.....
                </div>
            </div>
            <div style={{ width: "90%", alignItems: "center", justifyContent: "center", textAlign: "center", }}>
                <CharList />
            </div>
        </div>
    );
}

export default withAITracking(reactPlugin, Characters);
